import { gql } from "@apollo/client";

export const RETRY_DOCUMENT_VERIFICATION = gql`
  mutation retryDocumentVerification($input: RetryDocumentVerificationInput!) {
    retryDocumentVerification(input: $input) {
      commandId
      correlationId
    }
  }
`;
